









import Vue from 'vue';

export default Vue.extend({
	name: 'MoonLoader',

	props: {
		loading: {
			type: Boolean,
			default: true,
		},
		color: {
			type: String,
			default: '#37ca37',
		},
		size: {
			type: String,
			default: '60px',
		},
		margin: {
			type: String,
			default: '2px',
		},
		radius: {
			type: String,
			default: '100%',
		},
		customClass: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			spinnerStyle: {
				height: this.size,
				width: this.size,
				borderRadius: this.radius,

			},
		};
	},
	computed: {
		moonSize(): number {
			return parseFloat(this.size) / 7;
		},
		spinnerMoonStyle(): object {
			return {
				height: this.moonSize + 'px',
				width: this.moonSize + 'px',
				borderRadius: this.radius,
			};
		},
		animationStyle2(): object {
			return {
				top: parseFloat(this.size) / 2 - this.moonSize / 2 + 'px',
				backgroundColor: this.color,
			};
		},
		animationStyle3(): object {
			return {
				border: this.moonSize + 'px solid ' + this.color,
			};
		},
	},
});
